import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {formatDate, formatDateTime, formDate, handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import {getFamilyMemberTypes} from "../common/api/WebApi";
import {Chip} from "@mui/material";
import MDButton from "../../components/MDButton";
import Divider from "@mui/material/Divider";

export default function ViewFamilyMemberNotesModal({
                                                     familyMember,
                                                     handleCloseFamilyMember,
                                                     handleSaveFamilyMember,
                                                     show,
                                                     saving
                                                   }) {

  const [context, setContext] = useContext(AppContext);
  const [member, setMember] = useState(familyMember);
  const [emergencyContact, setEmergencyContact] = useState(familyMember?.emergencyContact);
  const [familyMemberTypes, setFamilyMemberTypes] = useState([]);
  const [typesReady, setTypesReady] = useState(false);
  const [dob, setDob] = useState();

  useEffect(() => {
    if (familyMember?.dob) {
      setDob(formDate(familyMember?.dob));
    }
  }, [familyMember?.dob]);

  useEffect(() => {
    let _dob = {...dob};
    try {
      let dd = new Date(dob);
      _dob = dd;
      let _member = {...member};
      _member.dob = dd;
      setMember(_member);
    } catch (err) {
      console.error(err);
    }
  }, [dob]);

  const [isNew, setIsNew] = useState(!!!familyMember?.guid);
  const [formInvalid, setFormInvalid] = useState(false);

  useEffect(() => {
    getFamilyMemberTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setFamilyMemberTypes(result);
        setTypesReady(true);
      }
    });
  }, [show]);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(member)
  });

  const handleCloseFamilyMemberFn = () => {
    handleCloseFamilyMember();
    setMember(null);
  };

  const handleSaveFamilyMemberFn = (data) => {
    handleSaveFamilyMember(data);
    setMember(null);
  };

  const toggleEmergencyContact = (e) => {
    setEmergencyContact(e.target.checked);
  };

  return (
    <Modal onHide={handleCloseFamilyMemberFn} size={'lg'} show={show}>
      <form onSubmit={handleSubmit(handleSaveFamilyMemberFn)} id={'memberForm'}>
        <Modal.Header closeButton>
          <Modal.Title>Family Member Notes - {familyMember?.firstName + ' ' + familyMember?.lastName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                {familyMember?.notes?.length <= 0 && <>
                  <Row className={"my-3"}>
                    <center>No notes for family member</center>
                  </Row>
                </>
                }
                {familyMember?.notes?.length > 0 && <>
                  <Row className={"my-3"}>

                    {familyMember?.notes?.sort((a, b) => a.createDate - b.createDate).filter((a) => a.pinned).map((note, idx) => {
                      return (
                        <Row index={idx} key={idx}>
                          <Col className={'col'} sm={12} xs={12}>
                            <p>
                              {note?.note}
                            </p>
                            <div>
                              <Chip
                                label={<>
                                  {!note.pinned ?
                                    <span
                                      style={{
                                        transform: 'rotate(15deg)'
                                      }}
                                      className="font-color-grey fa fa-thumbtack"></span>
                                    :
                                    <span
                                      className="font-color-gold fa fa-thumbtack"></span>
                                  }</>}
                                variant="outlined"
                              />
                              &nbsp;
                              <Chip
                                label={<>By: {note.createUser.firstName + ' ' + note.createUser.lastName} On: {formatDateTime(note.createDate)}</>}
                                variant="outlined"
                              />&nbsp;
                              {note.reminderNote && <>
                                <Chip
                                  label={<>Reminder Date: {formatDate(note.reminderDate)}</>}
                                  variant="outlined"
                                />&nbsp;
                              </>
                              }
                              <Divider/>
                            </div>

                          </Col>
                        </Row>
                      )
                    })}

                    {familyMember?.notes?.sort((a, b) => a.createDate - b.createDate).filter((a) => !a.pinned).map((note, idx) => {
                      return (
                        <Row index={idx} key={idx}>
                          <Col className={'col'} sm={12} xs={12}>
                            <p>
                              {note?.note}
                            </p>
                            <div>
                              <Chip
                                label={<>
                                  {!note.pinned ?
                                    <span
                                      style={{
                                        transform: 'rotate(15deg)'
                                      }}
                                      className="font-color-grey fa fa-thumbtack"></span>
                                    :
                                    <span
                                      className="font-color-gold fa fa-thumbtack"></span>
                                  }</>}
                                variant="outlined"
                              />
                              &nbsp;
                              <Chip
                                label={<>By: {note.createUser.firstName + ' ' + note.createUser.lastName} On: {formatDateTime(note.createDate)}</>}
                                variant="outlined"
                              />&nbsp;
                              {note.reminderNote && <>
                                <Chip
                                  label={<>Reminder Date: {formatDate(note.reminderDate)}</>}
                                  variant="outlined"
                                />&nbsp;
                              </>
                              }
                              <Divider/>
                            </div>

                          </Col>
                        </Row>
                      )
                    })}
                  </Row>
                </>
                }

              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="button"
                    onClick={()=>{
                      handleCloseFamilyMember()
                    }}
                    color="info" disabled={formInvalid || saving}>
           Close
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}